import React from "react";
import NotificationItem from "../NotificationItem/NotificationItem";
import styles from "./NotificationList.module.css";

export interface Notification {
    status: "error" | "warning" | "success" | "info";
    title: string;
    description: string;
    date: string;
    href: string;
}

interface Props {
    items: Array<Notification>;
}

const NotificationList = ({ items }: Props) => (
    <div className={styles.notificationList}>
        {items.map((item) => (
            <NotificationItem
                key={item.title}
                status={item.status}
                title={item.title}
                description={item.description}
                date={item.date}
                href={item.href}
            />
        ))}
    </div>
);

export default NotificationList;
